import styled from 'styled-components';

// A página inteira (o painel não usa o cabeçalho do app — ver index.js).
export const Wrap = styled.div`
  min-height: 100vh;
  background: #f6f5fb;
  padding: 26px 16px 60px;
  & > * { max-width: 900px; margin-left: auto; margin-right: auto; }
`;
export const Pagina = styled.div`
  min-height: 100vh;
  background: #f6f5fb;
  padding: 20px 16px 60px;
`;
export const Titulo = styled.h1`
  font-size: 22px;
  margin: 0 0 4px;
  color: #2b2940;
`;
export const Subtitulo = styled.p`
  margin: 0 0 18px;
  font-size: 13.5px;
  color: #7b7b8a;
  line-height: 1.5;
`;
export const Aviso = styled.div`
  background: #eef7f0;
  border: 1px solid #cfe6d6;
  border-radius: 12px;
  padding: 12px 14px;
  font-size: 13px;
  color: #35624a;
  line-height: 1.5;
  margin-bottom: 18px;
`;
export const Periodo = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 18px;
  flex-wrap: wrap;
`;
export const BotaoPeriodo = styled.button`
  border: 1px solid ${(p) => (p.ativo ? '#5a50c8' : '#e2e0ec')};
  background: ${(p) => (p.ativo ? '#5a50c8' : '#fff')};
  color: ${(p) => (p.ativo ? '#fff' : '#5a50c8')};
  border-radius: 999px;
  padding: 7px 15px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
`;
export const Bloco = styled.section`
  background: #fff;
  border: 1px solid #eceaf4;
  border-radius: 14px;
  padding: 16px 18px;
  margin-bottom: 14px;
  box-shadow: 0 1px 2px rgba(30,25,60,.04);
`;
export const TituloBloco = styled.h2`
  font-size: 15.5px;
  margin: 0 0 12px;
  color: #2b2940;
`;
export const Numeros = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;
export const Numero = styled.div`
  background: ${(p) => p.cor || '#f5f4fa'};
  border-radius: 12px;
  padding: 11px 14px;
  min-width: 108px;
  b {
    display: block;
    font-size: 21px;
    color: #2b2940;
    font-variant-numeric: tabular-nums;
    line-height: 1.2;
  }
  span {
    font-size: 11.5px;
    color: #6e6a86;
    line-height: 1.35;
    display: block;
    margin-top: 3px;
  }
`;
export const Nota = styled.p`
  margin: 10px 0 0;
  font-size: 12.5px;
  color: #7b7b8a;
  line-height: 1.5;
`;
export const Alerta = styled.p`
  margin: 10px 0 0;
  font-size: 12.5px;
  color: #9a5b12;
  background: #fdf3e2;
  border: 1px solid #f0dcb8;
  border-radius: 10px;
  padding: 9px 12px;
  line-height: 1.5;
`;
export const Tema = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 7px 0;
  border-bottom: 1px solid #f2f0f8;
  font-size: 13.5px;
  color: #3a3850;
  &:last-child { border-bottom: none; }
  b { font-variant-numeric: tabular-nums; color: #5a50c8; }
`;
export const PortaWrap = styled.div`
  max-width: 380px;
  margin: 0 auto;
  position: relative;
  top: 12vh;
  background: #fff;
  border: 1px solid #eceaf4;
  border-radius: 16px;
  padding: 26px 22px;
  text-align: center;
`;
export const Campo = styled.input`
  width: 100%;
  border: 1px solid #ddd9ec;
  border-radius: 10px;
  padding: 11px 12px;
  font-size: 15px;
  margin: 12px 0;
  text-align: center;
`;
export const Botao = styled.button`
  width: 100%;
  background: #5a50c8;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 11px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
`;
export const Erro = styled.p`
  color: #c0392b;
  font-size: 13px;
  margin: 8px 0 0;
`;
export const Sair = styled.button`
  background: none;
  border: none;
  color: #8b87a3;
  font-size: 12.5px;
  cursor: pointer;
  text-decoration: underline;
  margin-top: 16px;
`;
